<template lang="pug">
  div.crisis-evaluation
    div.module-title
      div.bar
      span 危机评价
      el-tooltip(effect="light" placement="bottom-start")
        div._tooltip__content(slot="content")
          p(style="font-weight: bold;font-size: 14px;margin-bottom: 5px;") 公关效果评价
          p 根据公关传播效果指数将危机公关划分为差（指数≤28.4）、较差
          p （28.4＜指数≤49.2）、一般（49.2＜指数≤71.2）、
          p 较好（71.2＜指数≤78.5）、好（指数＞78.5）。

          p(style="font-weight: bold;font-size: 14px;margin-top: 10px;margin-bottom: 5px;") 公关传播效果指数
          p 基于知微全媒体数据监测平台，采集网络媒体和自媒体（微博、微信为主）上的危机事件
          p 相关数据，梳理出危机事件的持续时间、公关介入的时间、媒体与社媒发布的内容友好度
          p 变化等指标，进行数据标准化后纳入指数计算。
        img(src="../assets/img/question.png" width=14 height=14)
    div.chart
      gauge-chart
      liquid-fill-chart
</template>

<script>
import LiquidFillChart from './LiquidFillChart'
import GaugeChart from './GaugeChart'
export default {
  name: 'CrisisEvaluation',
  components: {
    GaugeChart,
    LiquidFillChart
  }
}
</script>

<style lang="scss" scoped>
.crisis-evaluation {
  height: 406px;
  background-color: #ffffff;
  border-radius: 4px;
  padding: 14px;
  .module-title {
    display: flex;
    align-items: center;
    .bar {
      width: 4px;
      height: 14px;
      background-color: #f87653;
      border-radius: 2px;
      margin-right: 9px;
    }
    span {
      color: #333;
      font-size: 16px;
    }
    ._tooltip__content {
      padding: 10px;
      ._tooltip__title {
        font-weight: bold;
        margin-bottom: 5px;
        &:last-child {
          margin-top: 10px;
        }
      }
    }
    img {
      margin-left: 3px;
    }
  }
  .chart {
    display: flex;
    height: 300px;
    margin-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventGeneral/CrisisEvaluation.vue